import { render, staticRenderFns } from "./VendorRegister.vue?vue&type=template&id=5b35a842&scoped=true&"
import script from "./VendorRegister.vue?vue&type=script&lang=js&"
export * from "./VendorRegister.vue?vue&type=script&lang=js&"
import style0 from "./VendorRegister.vue?vue&type=style&index=0&id=5b35a842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35a842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VTextField})
